import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import {
  Edit,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from 'react-admin';

const useStyles = makeStyles({
  divFlex: {
    width: '48%',
  },
  divFlex2: {
    width: '48%',
  },
});

export const ShipmentsEditModal = (props) => {
  const classes = useStyles();
  return (
    <Box justifyContent="space-between" display="flex">
      <Show {...props} actions={false} className={classes.divFlex}>
        <SimpleShowLayout redirect={false}>
          <TextField
            sortable={false}
            source="trackingNumber"
            label="Tracking number"
          />
          <TextField
            sortable={false}
            source="localTrackingProvider"
            label="Local tacking provider"
          />
          <TextField sortable={false} source="dni" label="Dni" />
          <TextField sortable={false} source="weight" label="Weight" />
          <TextField sortable={false} source="value" label="Value" />
          <TextField
            sortable={false}
            source="description"
            label="Description"
          />
          <TextField sortable={false} source="user" label="User" />
          <TextField sortable={false} source="phone" label="Phone" />
          <TextField sortable={false} source="taxes" label="Taxes" />
          <TextField sortable={false} source="status" label="Status" />
        </SimpleShowLayout>
      </Show>
      <Edit
        className={classes.divFlex2}
        resource="shipments"
        basePath={props.basePath}
        {...props}
      >
        <SimpleForm redirect={false} >
          <TextInput type="number" source="taxes" />
          <SelectInput
            source="newStatus"
            allowEmpty
            choices={[
              { id: 'RECEIVED', name: 'Received' },
              { id: 'RETAINED', name: 'Retained' },
              { id: 'RELEASED', name: 'Released' },
            ]}
          />
        </SimpleForm>
      </Edit>
    </Box>
  );
};

export default ShipmentsEditModal;
